import React from "react";
import { Form } from "antd";
import CurrencyInput from "../CurrencyInput"; // adjust path if needed
import "./FormItem.scss";

const FormItemCurrencyInput = ({
  label,
  name,
  rules = [],
  placeholder = "Enter Amount",
  disabled = false,
  maxLength,
}) => {
  return (
    <Form.Item
      label={label}
      name={name}
      rules={rules}
      className={disabled ? "currency-input-disabled-fix" : undefined}
    >
      <CurrencyInput
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
      />
    </Form.Item>
  );
};

export default FormItemCurrencyInput;
